import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Career from "./pages/Career";
import PetitionRoute from "./components/PetitionRoute";
import RegisterInterestPage from "./RegisterInterestPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/careers" element={<Career />} />
        <Route path="/petition" element={<PetitionRoute />} />
        <Route path="/register" element={<RegisterInterestPage />} />
      </Routes>
    </Router>
  );
}

export default App;
